/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Task_Deadline_OverdueInputs */

const en_task_deadline_overdue = /** @type {(inputs: Task_Deadline_OverdueInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Overdue by ${i?.count} day`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Overdue by ${i?.count} days`);
	return /** @type {LocalizedString} */ ("task_deadline_overdue");
};

const pt_br2_task_deadline_overdue = /** @type {(inputs: Task_Deadline_OverdueInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pt-BR", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Vencida há ${i?.count} dia`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Vencida há ${i?.count} dias`);
	return /** @type {LocalizedString} */ ("task_deadline_overdue");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "Overdue by {count} day" |
* | "other" | "Overdue by {count} days" |
*
* @param {Task_Deadline_OverdueInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_deadline_overdue = /** @type {((inputs: Task_Deadline_OverdueInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Deadline_OverdueInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_deadline_overdue(inputs)
	return pt_br2_task_deadline_overdue(inputs)
});